export const FILGHT_CONSTANT = {
    VIOLATIONS:"storePolicyCart.e.storePolicyCart",
    VIOLATION:"storePolicyCart.violations",
    CHECKIN_BAGGAGE_INFO:"baggageInfo.baggageInfo.check_in_baggae",
    CABIN_BAGGAGE_INFO:"baggageInfo.baggageInfo.cabin_baggage"
}